import { DatePipe } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatesSummary } from '../../../entities';

type DateFormat = 'shortDate' | 'mediumDate' | 'longDate' | 'fullDate';

@Pipe({
  name: 'dateRange',
  standalone: true,
  pure: true,
})
export class DateRangePipe implements PipeTransform {
  private readonly datePipe = new DatePipe(inject(LOCALE_ID));

  transform(summary: DatesSummary | undefined | null, format: DateFormat = 'mediumDate'): string | null {
    if (!summary) return null;

    if (summary.state === 'NotStarted') return `No dates have been set for this trip yet.`;

    if (summary.state === 'GatheringAvailability') {
      return summary.rangeCriteria
        ? this.formatDateRange(summary.rangeCriteria.start, summary.rangeCriteria.end, format)
        : null;
    }

    return summary.selectedDates
      ? this.formatDateRange(summary.selectedDates.start, summary.selectedDates.end, format)
      : null;
  }

  private formatDateRange(start: Date, end: Date | undefined | null, format: DateFormat): string | null {
    if (end) {
      return `${this.datePipe.transform(start, format)} to ${this.datePipe.transform(end, format)}`;
    }
    return this.datePipe.transform(start, format);
  }
}
